import { BranchConfigData } from "../../../../../interfaces";

export class BranchesConfigParser {
    parseData(branchesConfig: BranchConfigData[]): BranchConfigData[] {
        branchesConfig.forEach(branch => { this.addMarketKeysProperty(branch) });
        return branchesConfig;
    }

     /* istanbul ignore next */
    addMarketKeysProperty(branch: BranchConfigData) {
        branch["MarketKeys"] = [];
        let marketKeys = branch["MarketKeys"];
        let regularTypeIdsArray: string[];

        branch.Markets.forEach(market => {
            let regularTypeIds = market["RegularTypeIds"];
            if (typeof regularTypeIds === "string" && regularTypeIds.length > 0) {
                regularTypeIdsArray = this.generateRegularTypeIdsArray(market.ID, regularTypeIds);
                regularTypeIdsArray.forEach(id => { marketKeys.push(id); });
            } else {
                marketKeys.push(market.ID.toString());
            }
        });
    }

     /* istanbul ignore next */
    generateRegularTypeIdsArray(marketID: number, regularTypeIds: string): string[] {
        return regularTypeIds
            .split(",")
            .map(id => `${marketID}_${id}`);
    }
}

export const branchesConfigParser = new BranchesConfigParser();